import { render, staticRenderFns } from "./AppDescription.vue?vue&type=template&id=fa8f711e"
import script from "./AppDescription.vue?vue&type=script&lang=js"
export * from "./AppDescription.vue?vue&type=script&lang=js"
import style0 from "./AppDescription.vue?vue&type=style&index=0&id=fa8f711e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports